import React from "react";
import { AppearedTestDetails, QuestionData } from "./data";
import {
  CheckOptionColor,
  CheckOptionSerial,
  CheckTagColor
} from "../../../../utils/helpers";
import { TAG_ARRAY } from "../../../../constants/TagConstants";

import { QuestionSVG, TimeLeftSVG } from "../../../../assets/svg";

interface ReportContainerProps {
  color: string;
  count: number;
  title: string;
}

const ReportContainer: React.FC<ReportContainerProps> = ({ color, count, title }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "30%",
        background: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "15px",
        borderRadius: "15px"
      }}
    >
      <p
        style={{
          color: color,
          fontSize: "64px",
          padding: "0px",
          margin: "0px",
          fontWeight: "600"
        }}
      >
        {count}
      </p>
      <p
        style={{
          color: color,
          fontSize: "24px",
          padding: "0px",
          margin: "0px",
          fontWeight: "500"
        }}
      >
        {title}
      </p>
    </div>
  );
};

interface OptionBoxProps {
  current_option: string;
  index: number;
  data: QuestionData;
}

const OptionBox: React.FC<OptionBoxProps> = ({ current_option, index, data }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        borderRadius: "5px",
        fontSize: "18px",
        fontWeight: "bold",
        gap: "10px",
        margin: "10px 0px"
      }}
    >
      <p
        style={{
          margin: "0px",
          padding: "0px",
          fontWeight: "400",
          fontSize: "20px",
          color: CheckOptionColor({
            data: data,
            current_option: current_option
          })
        }}
      >
        {CheckOptionSerial(index)}.
      </p>
      <p
        style={{
          margin: "0px",
          padding: "0px",
          fontWeight: "400",
          fontSize: "20px",
          color: CheckOptionColor({
            data: data,
            current_option: current_option
          })
        }}
      >
        {current_option}
      </p>
    </div>
  );
};

interface QuestionListProps {
  q: QuestionData;
  question_no: number;
}

const QuestionList: React.FC<QuestionListProps> = ({ q, question_no }) => {
  return (
    <div
      style={{
        width: "100%",
        background: "#DDDDDD",
        borderRadius: "15px",
        margin: "10px 0px",
        padding: "10px 20px"
      }}
    >
      {/* Question Tag */}
      <div
        style={{ display: "flex", flexDirection: "row", margin: "10px 0px" }}
      >
        <p
          style={{
            padding: "2px 12px",
            margin: "0px 4px",
            border: "1px solid #E6E6E6",
            borderRadius: "100px",
            background: "white",
            color: CheckTagColor(q?.tag)
          }}
        >
          #{q?.tag}
        </p>
      </div>

      {/* Questopn */}
      <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            fontWeight: "400",
            fontSize: "24px"
          }}
        >
          {question_no}.
        </p>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            fontWeight: "400",
            fontSize: "24px"
          }}
        >
          {q?.question}
        </p>
      </div>
      {/* Option Box */}

      <div
        style={{
          display: "grid",
          gridTemplateRows: "repeat(2, 1fr)",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "10px",
          width: "100%"
        }}
      >
        {q?.options?.map((item, i) => (
          <OptionBox key={i} current_option={item} index={i} data={q} />
        ))}
      </div>
    </div>
  );
};

const DetailsHeader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }}
  >
    <div style={{ display: "flex", gap: "20px" }}>
      <div>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            fontSize: "32px",
            fontWeight: "400"
          }}
        >
          Rahul Behera
        </p>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            fontSize: "20px",
            fontWeight: "400"
          }}
        >
          Senior Signal enginear
        </p>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          flexDirection: "row"
        }}
      >
        <p
          style={{
            fontSize: "38px",
            color: "#477BC4",
            fontWeight: "bold",
            textAlign: "center",
            padding: "0px",
            margin: "0px"
          }}
        >
          -
        </p>
      </div>

      <div>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            fontSize: "32px",
            fontWeight: "400",
            color: "#477BC4"
          }}
        >
          Quiz 4
        </p>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            fontSize: "20px",
            fontWeight: "400",
            color: "#477BC4"
          }}
        >
          12 sept 2024
        </p>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-evenly",
          flexDirection: "column"
        }}
      >
        <div className="quiz-detail">
          <QuestionSVG />
          <p className="quiz-detail-text">Number of Question: 25</p>
        </div>
        <div className="quiz-detail">
          <TimeLeftSVG />
          <p className="quiz-detail-text">Time Left: 20 min</p>
        </div>
      </div>
    </div>

    <div>
      <button className="download-button">Report</button>
    </div>
  </div>
);

const TestDetails = () => {
  return (
    <div
      style={{
        overflowY: "scroll",
        height: "94vh",
        flexGrow: "1",
        padding: "20px 40px"
      }}
    >
      <div style={{ width: "100%", height: "100px" }}>
        <DetailsHeader />
      </div>

      <div
        style={{
          width: "100%",
          background: "#DDDDDD",
          height: "317px",
          margin: "10px 0px",
          borderRadius: "100px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px"
        }}
      >
        {/* Left */}
        <div
          style={{
            height: "100%",
            width: "38%",
            background: "white",
            borderRadius: "15px"
          }}
        >
          {/* <TestChat /> */}
        </div>

        {/* Middle */}
        <div
          style={{
            height: "100%",
            width: "30%",
            justifyContent: "space-between",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <ReportContainer
            count={AppearedTestDetails?.correct_quiz}
            title={"Correct"}
            color={"#477BC4"}
          />
          <ReportContainer
            count={AppearedTestDetails?.incorrect_quiz}
            title={"Incorrect"}
            color={"#EF4444"}
          />
          <ReportContainer
            count={AppearedTestDetails?.unattempted_quiz}
            title={"Unattempt"}
            color={"#EF9944"}
          />
        </div>

        {/* Right */}
        <div style={{ height: "100%", width: "30%" }}>
          <div
            style={{
              height: "100%",
              width: "100%",
              background: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              borderRadius: "15px"
            }}
          >
            <p
              style={{
                color: "#1A6847",
                fontSize: "64px",
                padding: "0px",
                margin: "0px",
                fontWeight: "600"
              }}
            >
              {AppearedTestDetails?.total_score}
            </p>
            <p
              style={{
                color: "#1A6847",
                fontSize: "24px",
                padding: "0px",
                margin: "0px",
                fontWeight: "500"
              }}
            >
              Total Score
            </p>
          </div>
        </div>
      </div>

      {/* Tags */}
      <div
        style={{
          width: "100%",
          margin: "10px 0px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          {TAG_ARRAY?.map((tag, i) => (
            <p
              key={i}
              style={{
                padding: "2px 12px",
                margin: "0px 4px",
                border: "1px solid #E6E6E6",
                borderRadius: "100px",
                color: CheckTagColor(tag)
              }}
            >
              #{tag}
            </p>
          ))}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "6px",
            border: "1px solid #E6E6E6",
            borderRadius: "100px",
            padding: "3px 15px"
          }}
        >
          <p
            style={{
              padding: "0px",
              margin: "0px",
              fontSize: "20px",
              fontWeight: "600"
            }}
          >
            20
          </p>
          <p
            style={{
              padding: "0px",
              margin: "0px",
              fontSize: "20px",
              fontWeight: "400",
              opacity: "0.7"
            }}
          >
            question
          </p>
        </div>
      </div>

      {/* Question Box */}

      {AppearedTestDetails?.questions?.map((q, i) => (
        <QuestionList q={q} key={i} question_no={i + 1} />
      ))}
    </div>
  );
};

export default TestDetails;
